export default __webpack_public_path__ + "static/media/08AW1MAY66.9fe1f8e2.jpg";